




















import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFreeInputableWrappedObject } from "../objects/IFreeInputableWrappedObject";
import { DrawableObjectMixin } from "../objects/mixins";
import ToggleFreeInputMethodSelector from "../inputMethodEditors/ToggleFreeInputMethodSelector.vue";
import ClipboardMenu from "./ClipboardMenu.vue";
import ObjectMenuButton from "./ObjectMenuButton.vue";

@Component({
  components: {
    ClipboardMenu,
    ToggleFreeInputMethodSelector,
    ObjectMenuButton,
  }
})
export default class FreeInputtableObjectMenu extends Mixins() {
  @Prop()
  source: IFreeInputableWrappedObject & DrawableObjectMixin;

  @Prop()
  isInputMethodSelectable: boolean;

  @Prop()
  unselectedButtonConfiguration: { class: string, label: string, description: string };

  get isFreeInputable(): boolean {
    return this.source.isFreeInputable;
  }

  get selected(): boolean {
    return this.source.shouldInputFree;
  }

  set selected(value: boolean) {
    this.source.shouldInputFree = value;
    this.source.emitFocus();
  }
}
